import { Card, Grid, Skeleton, Stack } from "@mui/material";
import FlexBox from "../../components/layouts/Flexbox";

const CARD_COUNT = 6;

function InitiativeCardSkeleton() {
  return (
    <Card>
      <Stack gap={1.5}>
        <FlexBox alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={0.5}>
          <FlexBox alignItems="center" gap={0.5}>
            <Skeleton animation="wave" variant="circular" width={20} height={20} />
            <Skeleton animation="wave" variant="text" width={56} height={20} />
          </FlexBox>
          <FlexBox alignItems="center" gap={0.5}>
            <Skeleton animation="wave" variant="rounded" width={44} height={24} sx={{ borderRadius: "12px" }} />
            <Skeleton animation="wave" variant="circular" width={32} height={32} />
          </FlexBox>
        </FlexBox>
        <Skeleton animation="wave" variant="rectangular" width="100%" height={1} />
        <Skeleton animation="wave" variant="text" width="30%" height={22} />
        <Skeleton animation="wave" variant="text" width="85%" height={28} />
        <FlexBox alignItems="center" gap={0.5}>
          <Skeleton animation="wave" variant="text" width={120} height={20} />
          <Skeleton animation="wave" variant="text" width={80} height={20} />
        </FlexBox>
        <Skeleton animation="wave" variant="text" width="100%" height={20} />
        <Skeleton animation="wave" variant="text" width="90%" height={20} />
        <Skeleton animation="wave" variant="text" width="70%" height={20} />
      </Stack>
    </Card>
  );
}

export function InitiativesListSkeleton() {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: CARD_COUNT }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={`initiative-skeleton-${index}`}>
          <InitiativeCardSkeleton />
        </Grid>
      ))}
    </Grid>
  );
}
